// extracted by mini-css-extract-plugin
export default {"subscription":"Subscription_subscription__aftHl","subscription__text":"Subscription_subscription__text__zeKlN"};